import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape, propBool, propShape, } from '../../../../helpers/custom-prop-types';
import CustomSlider from '../../../Ui/Slider';
import SectionServiceOne from './SectionServiceOne';
const SectionService = (props) => {
    const { config, dataAttributes, isBlur, services } = props;
    return (_jsx("div", Object.assign({ className: 'about-consultant-service-list' }, { children: _jsx(CustomSlider, Object.assign({ className: 'slick-slider', config: config, dataAttributes: dataAttributes }, { children: services.map((service) => (_jsx(SectionServiceOne, { isBlur: isBlur, solution: service }, service.id))) })) })));
};
SectionService.propTypes = {
    config: propShape(),
    dataAttributes: propShape(),
    isBlur: propBool().isRequired,
    services: propArrayShape().isRequired,
};
SectionService.defaultProps = {
    config: {
        arrows: true,
        centerMode: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 800,
                settings: {
                    arrows: false,
                    dots: true,
                    rows: 1,
                },
            },
        ],
        rows: 2,
        slidesToShow: 1,
        speed: 300,
    },
    dataAttributes: {},
};
export default SectionService;
